import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
import {initItemcardImages} from "./custom/itemcardImages";
import {initRelatedProducts} from "./custom/relatedProducts";
import {openFullscreenGallery} from "../../../default/global/js/fullscreengallery";
import {initStickyBuybox} from "./custom/stickyBuybox";
import {Configurator2D} from "./custom/configurator2D";
import {initPconSetup} from "./custom/pcon";
import {checkQuantityValue} from "./custom/basket";
import {initAttributeInfoTooltips} from "./custom/attributeInfoTooltip";

window.addEventListener("load", (event) => {
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();
    initRelatedProducts();
    for (let item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item,".js-itemcardOpenGalleryItem");
        });
    }
    initStickyBuybox();
    initPconSetup();
    checkQuantityValue();
});

document.addEventListener("DOMContentLoaded", (event) => {
    // Not in the load handler: load waits for every image and third party script, the
    // buy button gate has to be in place as early as possible.
    new Configurator2D();
    initAttributeInfoTooltips();
});
